import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ObservationService } from "../../observation/service/observation.service";

export interface CardContent {
  card_id: number;
  card_id_1: number;
  card_name: string;
  card_id_2: number | null;
  card_name_2: string | null;
  card_value_1: string | null;
  card_date: string | null;
  card_value_2: string | null;
  card_user_id: number | null;
  card_username: string | null;
  card_user_image_url: string | null;
  card_image_url: string | null;
}

@Component({
  selector: "app-template-card",
  templateUrl: "./template-card.component.html",
  styleUrls: ["./template-card.component.css"],
})
export class TemplateCardComponent implements OnInit {
  constructor(
    private observationService: ObservationService,
    private router: Router
  ) { }
  @Input() cardContent!: CardContent;
  @Input() route!: string;

  initials!: { value: string; color: string };

  ngOnInit(): void {

  }

  fnItem(id: number | string) {
    const _router = "/" + this.route;
    // this.router.navigate([_router, id]);

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([_router, id]).then(() => {
      })
    })
  }

  time_ago(time: any) {
    switch (typeof time) {
      case "number":
        break;
      case "string":
        time = +new Date(time);
        break;
      case "object":
        if (time.constructor === Date) time = time.getTime();
        break;
      default:
        time = +new Date();
    }
    var time_formats = [
      [60, "seg", 1], // 60
      [120, "1 minuto atrás", "1 minuto desde ahora"], // 60*2
      [3600, "min", 60], // 60*60, 60
      [7200, "1 hora atrás", "1 hora desde ahora"], // 60*60*2
      [86400, "horas", 3600], // 60*60*24, 60*60
      [172800, "Ayer", "Mañana"], // 60*60*24*2
      [604800, "días", 86400], // 60*60*24*7, 60*60*24
      [1209600, "Últ. sem", "Siguiente semana"], // 60*60*24*7*4*2
      [2419200, "sem", 604800], // 60*60*24*7*4, 60*60*24*7
      [4838400, "Último mes", "Siguiente mes"], // 60*60*24*7*4*2
      [29030400, "meses", 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
      [58060800, "Último año", "Siguiente año"], // 60*60*24*7*4*12*2
      [2903040000, "años", 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
      [5806080000, "Último siglo", "Siguiente siglo"], // 60*60*24*7*4*12*100*2
      [58060800000, "sgl", 2903040000], // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
    ];
    var seconds = (+new Date() - time) / 1000,
      token = "",
      list_choice = 1;
    if (seconds == 0) {
      return "Justo ahora";
    }
    if (seconds < 0) {
      seconds = Math.abs(seconds);
      token = "desde ahora";
      list_choice = 2;
    }
    var i = 0,
      format;
    while ((format = time_formats[i++]))
      if (typeof format[0] == "number" && seconds < format[0]) {
        if (typeof format[2] == "string") {
          return format[list_choice];
        } else if (
          format[1] == "segundos" ||
          format[1] == "1 minuto atrás" ||
          format[1] == "minutos" ||
          format[1] == "1 hora atrás" ||
          format[1] == "horas"
        ) {
          return "Ayer";
        } else {
          return (
            Math.floor(seconds / format[2]) + " " + format[1] + " " + token
          );
        }
      }
    return time;
  }

  fnGoObsVar(_variety_name: string) {
    const _params = {
      p_any_date: true,
      p_variety_name: _variety_name
    };

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(["/observaciones"], {
        queryParams: _params
      }).then(() => {
      });
    });
  }
}
